import audienceHelpers from './helpers'
import { yellow } from '@/components/Analytics/common/theme.js'
import * as types from './mutation-types.js'
import { getApiFriendlyTimeframe } from '@/services/utilities/timeframePicker.js'
import technology from './nested/technology'
import downloads from './nested/downloads'
import dma from './nested/dma'
import overlap from './nested/overlap'

// initial state
const state = () => ({
  id: null, // activePodcastId for now, may switch to current account

  episode: null,
  podcast: null,
  network: null,
  campaign: null,

  // for comparison tables
  networks: [],
  podcasts: [],
  episodes: [],

  comparison: 'compare', // all/compare

  timeframe: null,
  timestamp: null,

  theme: yellow,

  // used for debugging api calls on a page
  apiCalls: {}
})

// getters
const getters = {

}

// actions
const actions = {
  getLocalAudienceState ({ commit }, id) {
    commit(types.SET_AUDIENCE_FROM_LOCAL_STATE, id)
  },
  setAudienceTheme ({ commit }, theme) {
    commit(types.SET_AUDIENCE_THEME, theme)
  },
  setAudienceTime ({ commit }, time) {
    commit(types.SET_AUDIENCE_TIMEFRAME, time)
  },
  setAudiencePodcast ({ commit }, podcast) {
    commit(types.SET_AUDIENCE_PODCAST, podcast)
    commit(types.SET_AUDIENCE_NETWORK, { id: 'all' })
  },
  setAudienceNetwork ({ commit }, network) {
    commit(types.SET_AUDIENCE_NETWORK, network)
    commit(types.SET_AUDIENCE_PODCAST, { id: 'all' })
  },
  setAudienceEpisode ({ commit }, episode) {
    commit(types.SET_AUDIENCE_EPISODE, episode)
  },
  setAudienceCampaign ({ commit }, campaign) {
    commit(types.SET_AUDIENCE_CAMPAIGN, campaign)
  },
  setAudienceCompareList ({ commit }, { compareList, mode}) {
    switch (mode) {
      case 'episode':
        commit(types.SET_AUDIENCE_EPISODES, compareList)
        break
      case 'podcast':
        commit(types.SET_AUDIENCE_PODCASTS, compareList)
        break
      case 'network':
        commit(types.SET_AUDIENCE_NETWORKS, compareList)
        break
    }
  },
  clearAPICalls ({ commit }) {
    commit(types.CLEAR_API_CALLS)
  },
  addAPICalls ({ commit }, apiCalls) {
    commit(types.ADD_API_CALLS, apiCalls)
  }
}

// mutations
const mutations = {
  [types.SET_AUDIENCE_FROM_LOCAL_STATE] (state, id) {
    state.id = id

    state.episode = audienceHelpers.episodeDefault(id)
    state.episodes = audienceHelpers.episodesDefault(id)
    state.podcast = audienceHelpers.podcastDefault(id)
    state.podcasts = audienceHelpers.podcastsDefault(id)
    state.network = audienceHelpers.networkDefault(id)
    state.networks = audienceHelpers.networksDefault(id)
    state.campaign = audienceHelpers.campaignDefault(id)
    state.timeframe = audienceHelpers.timeframeDefault(id)
    state.timestamp = audienceHelpers.timestampDefault(id)
    state.theme = audienceHelpers.themeDefault(id)
  },
  [types.SET_AUDIENCE_THEME] (state, theme) {
    state.theme = theme
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_TIMEFRAME] (state, time) {
    state.timeframe = getApiFriendlyTimeframe(time)
    state.timeframe.notLoaded = false
    state.timestamp = time
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_PODCAST] (state, podcast) {
    state.podcast = podcast
    if (podcast.id !== 'all') {
      state.podcasts = [podcast]
    }
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_PODCASTS] (state, podcasts) {
    state.podcasts = podcasts
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_NETWORK] (state, network) {
    state.network = network
    if (network.id !== 'all') {
      state.networks = [network]
    }
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_NETWORKS] (state, networks) {
    state.networks = networks
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_EPISODE] (state, episode) {
    state.episode = episode
    if (episode.id !== 'all') {
      state.episodes = [episode]
    }
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_EPISODES] (state, episodes) {
    state.episodes = episodes
    audienceHelpers.saveToSession(state)
  },
  [types.SET_AUDIENCE_CAMPAIGN] (state, campaign) {
    state.campaign = campaign
    audienceHelpers.saveToSession(state)
  },
  [types.CLEAR_API_CALLS] (state) {
    state.apiCalls = {}
  },
  [types.ADD_API_CALLS] (state, apiCalls) {
    state.apiCalls = {
      ...state.apiCalls,
      ...apiCalls
    }
  }
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters,
  modules: {
    technology,
    downloads,
    dma,
    overlap
  }
}
